import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuestionmarkFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "50px",
	height: "50px",
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M36 20c0 8.838-7.164 16-16 16S4 28.838 4 20c0-8.833 7.164-16 16-16s16 7.167 16 16ZM20.43 9.29c-3.517 0-5.759 1.481-7.52 4.114a.775.775 0 0 0 .175 1.049l2.239 1.697a.774.774 0 0 0 1.075-.137c1.152-1.462 1.943-2.31 3.697-2.31 1.318 0 2.948.849 2.948 2.127 0 .966-.797 1.462-2.099 2.192-1.517.85-3.526 1.91-3.526 4.559v.258c0 .427.347.774.774.774h3.613a.774.774 0 0 0 .775-.774v-.086c0-1.837 5.367-1.913 5.367-6.882 0-3.742-3.882-6.58-7.519-6.58Zm-.43 16a2.971 2.971 0 0 0-2.968 2.968A2.971 2.971 0 0 0 20 31.226a2.971 2.971 0 0 0 2.968-2.968A2.971 2.971 0 0 0 20 25.29Z" })
});
export default SvgQuestionmarkFill;
